var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load"},[_c('div',{staticClass:"load-wrapper"},[_c('div',{staticClass:"load-img",style:(_vm.barStyles)})])])}
var staticRenderFns = []

export { render, staticRenderFns }